import { getFullName } from './auth';
/**
 * 表示名取得
 * @param id
 * @param client
 * @returns {string}
 */
export const getViewName = ({ id }, client) => {
    if (client && id === client.id) {
        return 'あなた ';
    }
    return `${getFullName(client || {})} `;
};
/**
 * 初回返信済みかどうか判定
 * @param order
 * @returns {boolean}
 */
export const isDoneResponse = (order) => {
    const inquiry = order.inquiry || {};
    return !!inquiry.firstResponseAt;
};
/**
 * 現在の送付先の取得
 * @param solution
 * @param profile
 * @returns {*}
 */
export const getCurrentDestination = (solution, profile) => {
    const getZip = (information, organization) => {
        let zipCode1 = '';
        let zipCode2 = '';
        if (information.zipCode1 && information.zipCode2) {
            zipCode1 = information.zipCode1 || '';
            zipCode2 = information.zipCode2 || '';
        }
        else if (organization.zipCode1 && organization.zipCode2) {
            zipCode1 = organization.zipCode1 || '';
            zipCode2 = organization.zipCode2 || '';
        }
        return {
            zipCode1,
            zipCode2,
        };
    };
    const { destination, representative } = solution;
    const { information } = representative;
    const { organization } = profile;
    if (destination.type === 2) {
        // 責任者とは別の住所
        return Object.assign({}, destination);
    }
    return Object.assign({ address1: information.address1 || organization.address1, address2: information.address2 || organization.address2, address3: information.address3 || organization.address3, companyName: organization.name, departmentName: information.department, email: representative.email, firstName: information.firstName, lastName: information.lastName, prefecture: information.prefecture || organization.prefecture }, getZip(information, organization));
};
